<template>
    <div class="fixed bottom-0 inset-x-0 px-4 py-6 sm:inset-0 flex items-end sm:items-center sm:justify-center z-70 h-full"
    >
        <transition enter-active-class="ease-out duration-300"
                    enter-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100"
                    leave-to-class="opacity-0"
        >
            <div class="fixed inset-0 transition-opacity" v-show="show">
                <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
        </transition>

        <transition enter-active-class="ease-out duration-300"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
            <div class="bg-white max-h-full rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all w-full overflow-y-scroll sm:p-6"
                 :class="{ 'sm:max-w-xl': ! wide && ! large, 'sm:max-w-2xl': large, 'sm:max-w-5xl': wide, }"
                 role="dialog"
                 aria-modal="true"
                 aria-labelledby="modal-headline"
                 v-show="show"
            >
                <slot :hide="hide"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
            }
        },

        props: {
            large: {
                type: Boolean,
                default: false,
            },

            wide: {
                type: Boolean,
                default: false,
            }
        },

        created() {
            setTimeout(() => {
                this.show = true;
            }, 50);
        },

        methods: {
            hide() {
                this.show = false;

                setTimeout(() => {
                    this.$emit('hide');
                }, 300);
            }
        }
    }
</script>
